import {
  MenuItem,
  Select,
  SelectChangeEvent,
  Stack,
  TextField,
} from '@mui/material';
import { DateRange } from '@mui/x-date-pickers-pro';
import { Dayjs } from 'dayjs';
import { ChangeEvent } from 'react';
import { LastDateTimeRange, TimePeriodUnit } from '../types';

interface LastModeControlsProps {
  dateRange: DateRange<Dayjs | null>;
  timeRange: LastDateTimeRange;
  onChange: (timeRange: LastDateTimeRange) => void;
}

export function LastModeControls({
  timeRange,
  onChange,
}: LastModeControlsProps) {
  function onValueChange(event: ChangeEvent<HTMLInputElement>) {
    onChange({
      type: 'last',
      unit: timeRange.unit,
      value: Number(event.target.value),
    });
  }

  function onPeriodChange(event: SelectChangeEvent) {
    onChange({
      type: 'last',
      unit: event.target.value as TimePeriodUnit,
      value: timeRange.value,
    });
  }

  // Avoid showing 0
  const unitValue = timeRange.value ? timeRange.value : '';
  const menuItemlabelSuffix = (timeRange.value ?? 0) > 1 ? 's' : '';

  return (
    <Stack spacing={1} direction="row" justifyContent="center">
      <TextField
        value={unitValue}
        size="small"
        label="Last"
        variant="outlined"
        onChange={onValueChange}
        sx={{ maxWidth: '125px' }}
        inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
      />
      <Select
        id="calendar-select"
        value={timeRange.unit}
        size="small"
        onChange={onPeriodChange}
      >
        <MenuItem value={TimePeriodUnit.Month}>
          month{menuItemlabelSuffix}
        </MenuItem>
        <MenuItem value={TimePeriodUnit.Week}>
          week{menuItemlabelSuffix}
        </MenuItem>
        <MenuItem value={TimePeriodUnit.Day}>day{menuItemlabelSuffix}</MenuItem>
      </Select>
    </Stack>
  );
}
